import { Injectable } from "@angular/core";
import { HttpClientService } from "./http-client.service";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";
import { sendCodeParams, validateCodeParams } from "../types/bureau.types";

@Injectable()
export class CreditHistoryService {
  constructor(private http: HttpClientService) {}

  public perform(id): Observable<any> {
    return this.http
      .get("/api/credit_history/" + id + "/consultar")
      .pipe(tap((_) => console.log("CreditHistoryService.perform: Ok.")));
  }

  public download_again(id): Observable<any> {
    return this.http
      .put("/api/credit_history/" + id + "/download_again", {})
      .pipe(tap((_) => console.log("CreditHistoryService.download_again: Ok.")));
  }

  public dates(person_id): Observable<any> {
    return this.http
      .get("/api/persons/" + person_id + "/consultas_buros/fechas_exitosas")
      .pipe(tap((_) => console.log("CreditHistoryService.dates: Ok.")));
  }

  public get(id): Observable<any> {
    return this.http.get("/api/credit_history/" + id).pipe(tap((_) => console.log("CreditHistoryService.get: Ok.")));
  }

  public presence(country_state: string): Observable<boolean> {
    const options = { params: { estado: country_state } };
    return this.http
      .get("/api/consultas_buros/presencia", options)
      .pipe(tap((_) => console.log("CreditHistoryService.presence: Ok.")));
  }

  public send_code(params: sendCodeParams): Observable<any> {
    return this.http
      .post("/api/consultas_buros/send_code", params)
      .pipe(tap((_) => console.log("CreditHistoryService.send_code: Ok.")));
  }

  public validate_code(params: validateCodeParams): Observable<any> {
    return this.http
      .post("/api/consultas_buros/validate_code", params)
      .pipe(tap((_) => console.log("CreditHistoryService.validate_code: Ok.")));
  }

  public updatePresence(consulta_id: string | number, country_state: string): Observable<any> {
    let options = { estado_residencia: country_state };
    return this.http
      .put("/api/credit_history/" + consulta_id + "/update_residence", options)
      .pipe(tap((_) => console.log("CreditHistoryService.updatePresence: Ok.")));
  }

  public getInfo(id): Observable<any> {
    return this.http
      .get("/api/credit_history/" + id + "/parsed_xml")
      .pipe(tap((_) => console.log("CreditHistoryService.getInfo: Ok.")));
  }

  public getData(id): Observable<any> {
    return this.http
      .get("/api/credit_history/" + id + "/show_data")
      .pipe(tap((_) => console.log("CreditHistoryService.getData: Ok.")));
  }

  public assign(person_id, consulta_buro_id): Observable<Response> {
    return this.http
      .put("/api/persons/" + person_id + "/credit_history/" + consulta_buro_id + "/assign", null)
      .pipe(tap((_) => console.log("CreditHistoryService.assign: Ok.")));
  }

  public bestOfPersonId(person_id: string | number): Observable<any> {
    return this.http
      .get("/api/persons/" + person_id + "/credit_history/best")
      .pipe(tap((_) => console.log("CreditHistoryService.bestOfPersonId: Ok.")));
  }

  public create(consulta: any): Observable<any> {
    return this.http
      .post("/api/credit_history", { consulta_buro: consulta })
      .pipe(tap((_) => console.log("CreditHistoryService.create: Ok.")));
  }

  public updateAndDownloadAgain(consulta_buro: any, person_id = undefined): Observable<any> {
    return this.http
      .put("/api/credit_history/" + consulta_buro.id + "/update_and_download_again", { consulta_buro, person_id })
      .pipe(tap((_) => console.log("CreditHistoryService.updateAndDownloadAgain: Ok.")));
  }

  public createJob(id: string): Observable<any> {
    return this.http
      .get("/api/persons/" + id + "/credit_history/create_bc_job")
      .pipe(tap((_) => console.log("CreditHistoryService.createJob: Ok.")));
  }

  // # GET /api/consultas_buros/:id/bureau_accounts
  public getAccounts(id: string, { type = undefined }): Observable<any> {
    let options = {
      type,
    };
    return this.http
      .get("/api/consultas_buros/" + id + "/bureau_accounts", { params: options })
      .pipe(tap((_) => console.log("CreditHistoryService.getAccounts: Ok.")));
  }

  // # GET /api/consultas_buros/:id/bureau_requests
  public getRequests(id: string, { type = undefined }): Observable<any> {
    let options = {
      type,
    };

    return this.http
      .get("/api/consultas_buros/" + id + "/bureau_requests", { params: options })
      .pipe(tap((_) => console.log("CreditHistoryService.getRequests: Ok.")));
  }

  // # GET /api/consultas_buros/:id/bureau_requests/summary
  public getAutomotiveRequestsSummary(id: string, { type = undefined }): Observable<any> {
    let options = {
      type,
    };
    return this.http
      .get("/api/consultas_buros/" + id + "/bureau_requests/summary", { params: options })
      .pipe(tap((_) => console.log("CreditHistoryService.getAutomotiveRequestsSummary: Ok.")));
  }

  // # GET /api/consultas_buros/:id/automotive_queries
  public getAutomotiveQueries(id: string): Observable<any> {
    return this.http
      .get("/api/consultas_buros/" + id + "/automotive_queries")
      .pipe(tap((_) => console.log("CreditHistoryService.getAutomotiveQueries: Ok.")));
  }
}
